




















import { Component, Vue } from "vue-property-decorator";
import { getReportExample } from "@/api/api.config";

@Component
export default class Index extends Vue {
  imgUrl = "";
  id: any = "";

  created() {
    this.getReportExample();
    this.id = this.$route.query.id;
  }

  getReportExample() {
    getReportExample().then(({ data }: any) => {
      console.log(data[2]);
      if (this.id == 1) {
        this.imgUrl = data[2];
        console.log(this.imgUrl,'1')
      } else if (this.id == 2) {
        this.imgUrl = data[3];
        console.log(this.imgUrl,'2')

      }
    });
  }
}
